import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Table from "../components/table/Table";
import MenuOptions from "../components/threeDots/Menu";
import EdititingUser from "../components/EdititingUser";
import config from "../api/config";
import "../assets/css/customers.css";
import CustomSelect from "../components/select";
import { useDispatch, useSelector } from "react-redux";
import { setToast } from "../redux/actions/ToastAction";
import { Snackbar } from "@mui/material";
import Alert from "../components/alert";

const Customers = () => {
  const navigate = useHistory();
  const [users, setUsers] = useState([]);
  const [total, setTotal] = useState(0);
  const [totalUsers, setTotalUsers] = useState(0);
  const [currpage, setCurrPage] = useState(0);
  const [page, setPage] = useState(0);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState("");
  const [role, setRole] = useState(0);
  const roles = [
    "ROLE_USER",
    "ROLE_MODERATOR",
    "ROLE_ADMIN",
    "ROLE_SUPPER_ADMIN",
    ""
  ];
  // modal
  const [modal, setModal] = useState(false);
  const [editUser, setEditUser] = useState(null);

  // snackbar
  const reducer = useSelector((state) => state.reducer.toast);
  const dispatch = useDispatch();
  const toastHandler = () => {
    dispatch(setToast(false, "info", ""));
  };
  // search user
  const searchHandler = (e) => {
    setSearch(e.target.value);
    setLoading(true);
    config
      .get(`/api/user/v1?role=${roles[role]}&search=${e.target.value}&size=100`)
      .then((data) => {
        setLoading(false);

        setUsers(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });
  };

  // change pages
  const pageHandler = (page) => {
    setLoading(true);
    setPage(page);
    config
      .get(`/api/user/v1?page=${page}&role=${roles[role]}&size=100`)
      .then((data) => {
        setLoading(false);

        setUsers(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });

  };

  // rolechanger
  const roleHandler = (index) => {
    setRole(index);
    setLoading(true);
    config
      .get(`/api/user/v1?role=${roles[index]}&search=${search}&size=100`)
      .then((data) => {
        setLoading(false);

        setUsers(data.data.objectKoinot.content);
        setTotal(data.data.objectKoinot.totalPages);
        setCurrPage(data.data.objectKoinot.number);
      })
      .catch((err) => {
        console.error(err?.message);
        setLoading(false);
      });
    if (totalUsers === 0) {
      config
        .get("/api/statistics/v1/getCount")
        .then((data) => setTotalUsers(data.data.objectKoinot.userCount));
    }
  };

  // get data
  useEffect(() => {
    setLoading(true);
    config.get("/api/user/v1", { params: { role: "ROLE_USER", size: 100 } })
      .then(({ data }) => {
        setUsers(data.objectKoinot.content);
        setTotal(data.objectKoinot.totalPages);
        setCurrPage(data.objectKoinot.number);
      }).catch(() => dispatch(setToast(true, "error", "Не удалось загрузить пользователей")))
      .finally(() => setLoading(false));
    config.get("/api/statistics/v1/getCount")
      .then(({ data }) => setTotalUsers(data.objectKoinot.userCount))
      .catch(() => {});
  }, [dispatch]);

  // save edited user
  const saveHandler = async (bool, object) => {

    if (bool) {
      let olduser = JSON.parse(JSON.stringify(editUser));
      olduser.balance = object.balance;
      olduser.roles = object.roles;
      delete olduser.email;
      delete olduser.passportNumber;

      try {
        await config.post(`/api/user/v1/register`, olduser);

        setModal(false);
        pageHandler(page);
        dispatch(setToast(true, "success", "Успешно Изменено"));
      } catch (e) {
        console.error(e?.message);
      }
    }
  };

  // table data
  const headData = [
    "Name",
   "",
    "Count Key",
    "Balance (so'm)",
    "Roles",
  ];
  const renderHead = (item, index) => <th key={index}>{item}</th>;
  // menu data
  const renderBody = (item, index, func) => (
    <tr key={index}>
      <td>
        <p>
          {" "}
          {item.firstName} {item.lastName}
        </p>
      </td>
      <td className="">
        <span> {item.phoneNumber} </span>
      </td>
      {/* <td>
        <a href={item.url} target="_blank">
          {item.url}
        </a>
      </td> */}
      <td>
        <p> {item.countKey ? item.countKey : 0}</p>
      </td>
      <td>
        <span>{item.balance ? item.balance : 0}</span>
      </td>
      <td>
        <ul>
          {item.roles.map((item, index) => (
            <li key={index}>{item}</li>
          ))}
        </ul>
      </td>
      <td>
        <MenuOptions
          options={[
            {
              value: "Изменять",
              callback: () => {
                setEditUser(item);
                setModal(true);
              },
            },
            {
              value: "Посмотреть историю",
              callback: () => {
                navigate.push({
                  pathname: "/search-history",
                  user: item.telegramId,
                });},
            },
          ]}
        />
      </td>
    </tr>
  );

  return (
    <div>
      <Snackbar
        open={reducer.toast}
        autoHideDuration={4000}
        onClose={toastHandler}
      >
        <Alert
          onClose={toastHandler}
          severity={reducer.severity}
          sx={{ width: "100%" }}
        >
          {reducer.content}
        </Alert>
      </Snackbar>
      <EdititingUser
        user={editUser}
        _callback={saveHandler}
        modal={modal}
        setModal={() => setModal(!modal)}
      />
      <h2 className="page-header">Пользователи</h2>
      {totalUsers > 0 && (
        <p className="fw-bold">
          Общее количество пользователей:
          <span className="fw-bold second-color">{totalUsers}</span>
        </p>
      )}

      <div className="row pb-5">
        <div className="col-12">
          <div className="row">
            <div className="col-md-6 col-sm-12">
              <input type="text" value={search} onChange={searchHandler} />
            </div>
            <div className="col-md-6 col-sm-12 col-md-offset-2">
              <CustomSelect
                selVal={role}
                selItems={roles}
                type={"outlined"}
                selHandle={(e) => {
                  roleHandler(e);

                }}
              />
            </div>
          </div>

          <Table
            headData={headData}
            renderHead={(item, index) => renderHead(item, index)}
            bodyData={users}
            renderBody={(item, index) => renderBody(item, index)}
            pages={total}
            currPage={currpage}
            changePage={pageHandler}
            loading={loading}
          />
        </div>
      </div>
    </div>
  );
};

export default Customers;
